module.exports = __webpack_public_path__ + "static/media/confirmation.798738ad.png";